var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map((p=>{return+p==p?+p:p}))},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = (msg) => {
	throw new Error(msg);
}
var failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = (fn) => (function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

var useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	64298: () => (loadSingletonVersion("default", "react", false, [1,18,0], () => (Promise.all([__webpack_require__.e(997), __webpack_require__.e(224), __webpack_require__.e(145), __webpack_require__.e(55), __webpack_require__.e(221), __webpack_require__.e(70), __webpack_require__.e(689)]).then(() => (() => (__webpack_require__(86326))))))),
	81886: () => (loadSingletonVersion("default", "react-dom", false, [1,18,0], () => (Promise.all([__webpack_require__.e(997), __webpack_require__.e(224), __webpack_require__.e(145), __webpack_require__.e(55), __webpack_require__.e(221), __webpack_require__.e(70), __webpack_require__.e(689)]).then(() => (() => (__webpack_require__(35623))))))),
	1791: () => (loadStrictVersion("default", "@fortawesome/react-fontawesome", false, [2,0,2,0], () => (Promise.all([__webpack_require__.e(997), __webpack_require__.e(224), __webpack_require__.e(145), __webpack_require__.e(55), __webpack_require__.e(221), __webpack_require__.e(70), __webpack_require__.e(689)]).then(() => (() => (__webpack_require__(35798))))))),
	79578: () => (loadStrictVersion("default", "@imaginelearning/mps-icon-library", false, [1,1,0,40], () => (__webpack_require__.e(37).then(() => (() => (__webpack_require__(15037))))))),
	40989: () => (loadStrictVersion("default", "@imaginelearning/mps-ux-component-library", false, [1,6,0,40], () => (Promise.all([__webpack_require__.e(997), __webpack_require__.e(224), __webpack_require__.e(145), __webpack_require__.e(55), __webpack_require__.e(221), __webpack_require__.e(70), __webpack_require__.e(689), __webpack_require__.e(290), __webpack_require__.e(31), __webpack_require__.e(771), __webpack_require__.e(372)]).then(() => (() => (__webpack_require__(8891))))))),
	45330: () => (loadStrictVersion("default", "react-i18next", false, [1,11,11,1], () => (Promise.all([__webpack_require__.e(997), __webpack_require__.e(224), __webpack_require__.e(145), __webpack_require__.e(55), __webpack_require__.e(221), __webpack_require__.e(70), __webpack_require__.e(689)]).then(() => (() => (__webpack_require__(65745))))))),
	96281: () => (loadStrictVersion("default", "@imaginelearning/mps-api-service", false, [1,7,0,40], () => (Promise.all([__webpack_require__.e(997), __webpack_require__.e(224), __webpack_require__.e(145), __webpack_require__.e(55), __webpack_require__.e(221), __webpack_require__.e(70), __webpack_require__.e(689), __webpack_require__.e(799)]).then(() => (() => (__webpack_require__(54799))))))),
	22076: () => (loadStrictVersion("default", "react-router", false, [4,6,14,2], () => (Promise.all([__webpack_require__.e(997), __webpack_require__.e(224), __webpack_require__.e(145), __webpack_require__.e(55), __webpack_require__.e(221), __webpack_require__.e(70), __webpack_require__.e(689)]).then(() => (() => (__webpack_require__(42277))))))),
	1148: () => (loadStrictVersion("default", "react-router-dom", false, [4,6,14,2], () => (Promise.all([__webpack_require__.e(997), __webpack_require__.e(224), __webpack_require__.e(145), __webpack_require__.e(55), __webpack_require__.e(221), __webpack_require__.e(70), __webpack_require__.e(689)]).then(() => (() => (__webpack_require__(4194))))))),
	2730: () => (loadStrictVersion("default", "@sentry/browser", false, [1,7,40,0], () => (Promise.all([__webpack_require__.e(997), __webpack_require__.e(224), __webpack_require__.e(145), __webpack_require__.e(55), __webpack_require__.e(221), __webpack_require__.e(70), __webpack_require__.e(689)]).then(() => (() => (__webpack_require__(93033))))))),
	4434: () => (loadStrictVersion("default", "@newrelic/browser-agent", false, [1,1,291,1], () => (Promise.all([__webpack_require__.e(997), __webpack_require__.e(224), __webpack_require__.e(145), __webpack_require__.e(55), __webpack_require__.e(221), __webpack_require__.e(70), __webpack_require__.e(689), __webpack_require__.e(730)]).then(() => (() => (__webpack_require__(61869))))))),
	30508: () => (loadStrictVersion("default", "oidc-client", false, [1,1,11,5], () => (Promise.all([__webpack_require__.e(997), __webpack_require__.e(224), __webpack_require__.e(145), __webpack_require__.e(55), __webpack_require__.e(221), __webpack_require__.e(70), __webpack_require__.e(689)]).then(() => (() => (__webpack_require__(36123))))))),
	47652: () => (loadStrictVersion("default", "react-idle-timer", false, [1,4,6,4], () => (Promise.all([__webpack_require__.e(997), __webpack_require__.e(224), __webpack_require__.e(145), __webpack_require__.e(55), __webpack_require__.e(221), __webpack_require__.e(70), __webpack_require__.e(689)]).then(() => (() => (__webpack_require__(20376))))))),
	57500: () => (loadStrictVersion("default", "i18next-browser-languagedetector", false, [1,6,1,2], () => (Promise.all([__webpack_require__.e(997), __webpack_require__.e(224), __webpack_require__.e(145), __webpack_require__.e(55), __webpack_require__.e(221), __webpack_require__.e(70), __webpack_require__.e(689)]).then(() => (() => (__webpack_require__(60134))))))),
	64902: () => (loadStrictVersion("default", "dayjs", false, [1,1,11,5], () => (Promise.all([__webpack_require__.e(997), __webpack_require__.e(224), __webpack_require__.e(145), __webpack_require__.e(55), __webpack_require__.e(221), __webpack_require__.e(70), __webpack_require__.e(689)]).then(() => (() => (__webpack_require__(94343))))))),
	67538: () => (loadStrictVersion("default", "react-bootstrap", false, [1,2,10,4], () => (Promise.all([__webpack_require__.e(997), __webpack_require__.e(224), __webpack_require__.e(145), __webpack_require__.e(55), __webpack_require__.e(221), __webpack_require__.e(70), __webpack_require__.e(689)]).then(() => (() => (__webpack_require__(43046))))))),
	73331: () => (loadStrictVersion("default", "html2canvas", false, [1,1,4,1], () => (Promise.all([__webpack_require__.e(997), __webpack_require__.e(224), __webpack_require__.e(145), __webpack_require__.e(55), __webpack_require__.e(221), __webpack_require__.e(70), __webpack_require__.e(689)]).then(() => (() => (__webpack_require__(72052))))))),
	87485: () => (loadStrictVersion("default", "@imaginelearning/mps-shared-component-library", false, [1,6,0,40], () => (Promise.all([__webpack_require__.e(997), __webpack_require__.e(224), __webpack_require__.e(145), __webpack_require__.e(55), __webpack_require__.e(221), __webpack_require__.e(70), __webpack_require__.e(689), __webpack_require__.e(585), __webpack_require__.e(171), __webpack_require__.e(366), __webpack_require__.e(691)]).then(() => (() => (__webpack_require__(99691))))))),
	90324: () => (loadStrictVersion("default", "i18next", false, [1,20,3,2], () => (Promise.all([__webpack_require__.e(997), __webpack_require__.e(224), __webpack_require__.e(145), __webpack_require__.e(55), __webpack_require__.e(221), __webpack_require__.e(70), __webpack_require__.e(689)]).then(() => (() => (__webpack_require__(40680))))))),
	97162: () => (loadStrictVersion("default", "i18next-xhr-backend", false, [1,3,2,2], () => (Promise.all([__webpack_require__.e(997), __webpack_require__.e(224), __webpack_require__.e(145), __webpack_require__.e(55), __webpack_require__.e(221), __webpack_require__.e(70), __webpack_require__.e(689)]).then(() => (() => (__webpack_require__(64884))))))),
	20366: () => (loadStrictVersion("default", "@sentry/browser", false, [1,7,40,0], () => (Promise.all([__webpack_require__.e(997), __webpack_require__.e(224), __webpack_require__.e(145), __webpack_require__.e(55), __webpack_require__.e(221), __webpack_require__.e(70), __webpack_require__.e(689)]).then(() => (() => (__webpack_require__(43312)))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"76": [
		22076
	],
	"298": [
		64298
	],
	"366": [
		20366
	],
	"516": [
		1791,
		79578
	],
	"598": [
		40989,
		45330,
		96281
	],
	"659": [
		1148,
		2730,
		4434,
		30508,
		47652,
		57500,
		64902,
		67538,
		73331,
		87485,
		90324,
		97162
	],
	"886": [
		81886
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}